export const environment = {
  production: false,
  apiPrivateUrl: 'https://api-dev-platfrom.cityparking.asia',
  webPayUrl: 'https://webpay.cityparking.asia',
  // apiPrivateUrl: 'https://api-platfrom.cityparking.asia',
  // apiPrivateUrl: 'https://api.cityparking.asia',
  // apiPrivateUrl: 'https://localhost:44324',
  // apiPrivateUrl: 'http://localhost:5000',
  // apiPrivateUrl: 'http://localhost:5195',
  // Console log ทุกการเข้า-ออก (HTTP request/response + route enter/leave)
  debugLog: {
    enabled: true, // master switch / เปิด-ปิดทั้งหมด
    http: true, // log HTTP request out / response in
    router: true, // log page enter / leave
    payload: true, // include request/response body
  },
};
